import { defineComponent, createBlock, openBlock, withCtx, createVNode } from "vue";
import FlowButton from "./FlowButton.vue.js";
import _sfc_main$1 from "./FlowIcon.vue.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FlowIconButton",
  props: {
    label: {},
    icon: {},
    variant: { default: "clear" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(FlowButton, {
        class: "icon-button",
        icon: "",
        label: _ctx.label,
        variant: _ctx.variant
      }, {
        default: withCtx(() => [
          createVNode(_sfc_main$1, { icon: _ctx.icon }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["label", "variant"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FlowIconButton.vue.js.map
